import React, { useState } from 'react';
import { 
  Box, 
  Grid, 
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ChatContainer from '../components/chat/ChatContainer';
import ContextColumn from '../components/chat/ContextColumn';
import SuggestionsColumn from '../components/chat/SuggestionsColumn';

// Import text content
import { documentsTexts } from '../texts/documents';

/**
 * Chat page component
 * 
 * This page hosts the chat interface for user interactions with the assistant
 * It uses the ChatContainer component which handles all chat functionality
 * 
 * @returns {JSX.Element} Rendered component
 */
const Chat = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedContext, setSelectedContext] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState('');
  
  // Get collections from documents.js
  const collections = documentsTexts.collections.collections;
  
  // Transform collections to context cards format
  const contextCards = collections.map(collection => ({
    id: collection.id,
    title: collection.name,
    link: collection.link
  }));
  
  // Get suggested questions based on selected context
  const getSuggestedQuestions = () => {
    if (!selectedContext) {
      // Return questions from the first collection as default
      return collections[0]?.suggestedQuestions || [];
    }
    
    const selectedCollection = collections.find(
      collection => collection.id === selectedContext
    );
    
    return selectedCollection?.suggestedQuestions || [];
  };
  
  const handleContextChange = (id) => {
    setSelectedContext(id);
  };
  
  const handleQuestionClick = (question) => {
    setSelectedQuestion(question);
  };
  
  const handleQuestionUsed = () => {
    setSelectedQuestion('');
  };
  
  return (
    <Box sx={{ 
      flex: 1,
      bgcolor: 'background.default',
      pt: 2
    }}>
      <Grid container 
        spacing={3}
        sx={{
          height: '100%',
          padding: isMobile ? 0 : 2,
          justifyContent: 'center',
        }}
      >
        <Grid item size={{xs: 12, md: 3}}>
          <ContextColumn 
            contextCards={contextCards} 
            selectedContext={selectedContext} 
            onContextChange={handleContextChange} 
          />
        </Grid>

        <Grid item size={{xs: 12, md: 6}} sx={{ minHeight: '800px' }}>
          <ChatContainer 
            title="Hola, ¿en qué puedo ayudarte?"
            selectedQuestion={selectedQuestion}
            onQuestionUsed={handleQuestionUsed}
          />
        </Grid>

        <Grid item size={{xs: 12, md: 3}}>
          <SuggestionsColumn 
            suggestedQuestions={getSuggestedQuestions()} 
            onQuestionClick={handleQuestionClick} 
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Chat;
